(function () {
  function initStickyAddToCart(root) {
    var sectionId = root.dataset.sectionId;
    var priceEl = document.getElementById('StickyAddToCartPrice-' + sectionId);
    var button = document.getElementById('StickyAddToCartButton-' + sectionId);
    var buttonText = button ? button.querySelector('span') : null;
    var realSubmitButton = document.getElementById('ProductSubmitButton-' + sectionId);
    var realBuyButtons = realSubmitButton ? realSubmitButton.closest('.product-form__buttons') : null;
    var priceContainer = document.getElementById('price-' + sectionId);

    if (!button || !realSubmitButton || !realBuyButtons) return;

    function isRealButtonDisabled() {
      return realSubmitButton.hasAttribute('disabled') || realSubmitButton.getAttribute('aria-disabled') === 'true';
    }

    function syncState() {
      var disabled = isRealButtonDisabled();
      button.disabled = disabled;
      if (buttonText && window.variantStrings) {
        buttonText.textContent = disabled ? window.variantStrings.soldOut : window.variantStrings.addToCart;
      }
    }

    function syncPrice() {
      if (!priceContainer || !priceEl) return;
      var saleEl = priceContainer.querySelector('.price-item--last');
      var regularEl = priceContainer.querySelector('.price__regular .price-item--regular');
      var source = saleEl && saleEl.offsetParent !== null ? saleEl : regularEl;
      if (source && source.textContent.trim()) {
        priceEl.textContent = source.textContent.trim();
      }
    }

    button.addEventListener('click', function () {
      if (isRealButtonDisabled()) return;
      realSubmitButton.click();
    });

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.variantChange, function (evt) {
        if (evt.data.sectionId !== sectionId) return;
        syncState();
        syncPrice();
      });
    }

    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            root.hidden = entry.isIntersecting;
            document.body.classList.toggle('sticky-atc-visible', !entry.isIntersecting);
          });
        },
        { threshold: 0 }
      );
      observer.observe(realBuyButtons);
    }

    syncState();
    syncPrice();
  }

  document.querySelectorAll('[data-sticky-add-to-cart]').forEach(initStickyAddToCart);
})();
